export default "/images/promotional_sms.png?d665fe52153f46c5c3929d0cd57c8e61";